import * as React from "react";

const SvgEditTime = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 25 24"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.9 20.3a8.8 8.8 0 0 0 3.512.7 8.8 8.8 0 0 0 3.512-.7 9 9 0 0 0 2.863-1.925 9 9 0 0 0 1.925-2.863 8.8 8.8 0 0 0 .7-3.512v-.5q0-.225-.05-.5h-2.05q.05.275.075.5t.025.5q0 2.95-2.025 4.975T12.412 19t-4.975-2.025T5.412 12t2.025-4.975T12.412 5q.525 0 1.012.075t.988.225V3.25a7.959 7.959 0 0 0-2-.25 8.8 8.8 0 0 0-3.513.7 9 9 0 0 0-2.862 1.925 9 9 0 0 0-1.925 2.863 8.8 8.8 0 0 0-.7 3.512q0 1.874.7 3.512a9 9 0 0 0 1.925 2.863A9 9 0 0 0 8.899 20.3m2.512-7.9 3.8 3.8 1.4-1.4-3.2-3.2V7h-2zm9.054-3.735-.03.433-.434-.031-2.479-2.855.464-.401zM16.24 5.68l1.393-1.22-.41-.472a.56.56 0 0 0-.417-.2.62.62 0 0 0-.443.154l-.463.402a.6.6 0 0 0-.21.423.6.6 0 0 0 .148.45zm4.864 2.767L18.057 4.94 16.65 6.158l3.046 3.508 1.315.093z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgEditTime;
